import { useFormContext } from 'react-hook-form';
import React from 'react';
import { REGENERATE_STATUS_LABELS, REPORT_TYPES } from '../../../../../config/constants/reportConstants';
import { AutocompleteArrayInput, DateInput, SelectArrayInput, SelectInput, TextInput } from 'react-admin';
import { setChoices, timezones } from '../../../../../helpers';
import { CustomPaper } from '../../../../helperComponents/CustomPaper';
import { reportTypesMapToPlatform } from '../../../../../helpers/constants';
import { JsonBooleanInput } from '../../../../helperComponents/JsonBooleanInput';

const isAppsFlyerType = reportType => (
    reportType === REPORT_TYPES.META_MEDIA_APPS_FLYER_MASTER ||
    reportType === REPORT_TYPES.GOOGLE_MEDIA_APPS_FLYER_MASTER ||
    reportType === REPORT_TYPES.GOOGLE_UAC_APPS_FLYER_MASTER
);

export const ReportTypeDependentFieldsEdit = ({
  accounts,
  affiliates,
  uniqueGoals,
  uniqueMediaSources,
  uniqueEventNames,
  record
}) => {
    const { watch } = useFormContext()
    const reportType = watch('report_type') ?? record?.report_type ?? null;

    return (
        <>
            {reportType === REPORT_TYPES.META_MEDIA_APPS_FLYER_MASTER ? (
                <TextInput source="timezone" label="Timezone" defaultValue="GMT+2" disabled />
            ) : reportType === REPORT_TYPES.SEARCH_TERMS_MASTER ||
                reportType === REPORT_TYPES.GOOGLE_MEDIA_APPS_FLYER_MASTER ||
                reportType === REPORT_TYPES.GOOGLE_UAC_APPS_FLYER_MASTER ? null : (
                <SelectInput
                    source="timezone"
                    label="Timezone"
                    defaultValue={record?.timezone}
                    choices={setChoices(timezones)}
                    required
                    emptyText="Choose timezone"
                />
            )}

            {isAppsFlyerType(reportType) ? (
                <AutocompleteArrayInput
                    label="AppsFlyer Media Source"
                    source="media_sources"
                    defaultValue={record?.media_sources}
                    choices={uniqueMediaSources.map(mediaSource => ({
                        id: mediaSource,
                        name: `appsFlyer - ${mediaSource}`
                    }))}
                    PaperComponent={props => (
                        <CustomPaper {...props} width="670px" elevation={8} margin="0 0 0 150px" />
                    )}
                    fullWidth
                />
            ) : reportType === REPORT_TYPES.SEARCH_TERMS_MASTER ? null : (
                <AutocompleteArrayInput
                    label="Affiliate IDs"
                    source="affiliate_ids"
                    defaultValue={record?.affiliate_ids}
                    choices={affiliates.map(affiliate => ({
                        id: affiliate.affiliate_id,
                        name: `${affiliate.affiliate_id} - ${affiliate.affiliate}`
                    }))}
                    PaperComponent={props => (
                        <CustomPaper {...props} width="670px" elevation={8} margin="0 0 0 150px" />
                    )}
                    fullWidth
                />
            )}

            <SelectInput
                source="status"
                defaultValue={record?.status}
                choices={setChoices(REGENERATE_STATUS_LABELS)}
                required
                emptyText="Choose a status"
            />

            <SelectArrayInput
                source="internal_account_ids"
                label="Internal Account IDs"
                choices={accounts.filter(({ platform }) =>
                    platform === reportTypesMapToPlatform.get(reportType)
                )}
                disabled={!reportType}
            />

            <DateInput source="default_start_date" defaultValue={record?.default_start_date} />

            {isAppsFlyerType(reportType) ? (
                <SelectArrayInput
                    source="event_names"
                    defaultValue={record?.event_names}
                    label="AppsFlyer Events"
                    choices={setChoices(uniqueEventNames)}
                />
            ) : reportType === REPORT_TYPES.SEARCH_TERMS_MASTER ? null : (
                <SelectArrayInput
                    source="goal_names"
                    defaultValue={record?.goal_names}
                    label="Goal names"
                    choices={setChoices(uniqueGoals)}
                />
            )}

            {reportType && !isAppsFlyerType(reportType) && (
                <JsonBooleanInput
                    source="exclude_rejected_sales"
                    jsonSource="settings"
                    label="Exclude Rejected Sales"
                    defaultValue={false}
                />
            )}
        </>
    )
}
